import React, { useEffect, useState } from 'react'

import { Col, Layout, Row, Space, Typography } from 'antd'

import './Footer.css'
import { GMCCDisclaimer } from 'GMCCCalculator/Disclaimer'

const { Paragraph } = Typography
const { Footer } = Layout

interface FooterProps {
    scrollToSection: (section: string) => void
    basicInfo: any
    aboutInfo: any
    customerID: string
    showedModules: string[] | undefined
}

const tabs = [
    { key: 'aboutMe', label: 'About Me' },
    { key: 'gmccSpecials', label: 'Specials' },
    { key: 'rates', label: 'Rates' },
    { key: 'affordability', label: 'Affordability' },
    { key: 'myCompany', label: 'My Company' },
    { key: 'reviews', label: 'Reviews' },
    { key: 'faq', label: 'FAQ' },
    { key: 'requireCallback', label: 'Contact' },
]

const FooterWrapStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 0 0 0',
    
}

const RootFooter = ({
    scrollToSection,
    basicInfo,
    aboutInfo,
    customerID,
    showedModules,
}: FooterProps) => {

    const [displayModules, setDisplayModules] = useState(tabs)
    const displaySocialMedia =
        aboutInfo &&
        (aboutInfo.twitter ||
            aboutInfo.linkedin ||
            aboutInfo.google ||
            aboutInfo.yelp)

    useEffect(() => {
        let showModules = tabs.filter((tab) => showedModules?.includes(tab.key))
        setDisplayModules(showModules)
    }, [showedModules])


    return (
        <Footer
            style={customerID != 'gmcc' ? FooterWrapStyle : {...FooterWrapStyle, flexDirection: 'column'}}
        >
            <Row className="landing-page-footer d-flex flex-row justify-content-between align-items-start">
                <Col span={24} md={4} style={{ marginBottom: '30px' }}>
                    <div className="d-flex align-items-start h-100">
                        <img
                            className="footer-company-logo"
                            src={
                                (aboutInfo && aboutInfo.companyLogo) ||
                                '/images/logo.svg'
                            }
                            alt="Zeitro Marketplace"
                        />
                    </div>
                </Col>
                <Col span={24} md={20}>
                    <Row
                        gutter={[16, 16]}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}
                    >
                        <Col span={12} md={6}>
                            <Row className="footer-header">Sitemap</Row>
                            {displayModules.map((tab, index) => (
                                <Row
                                    key={index}
                                    className="footer-link"
                                    onClick={() => {
                                        scrollToSection(tab.key)
                                    }}
                                >
                                    {tab.label}
                                </Row>
                            ))}
                        </Col>
                        {aboutInfo && aboutInfo.phone && aboutInfo.email && (
                            <Col span={12} md={6}>
                                <Row className="footer-header">Contact</Row>
                                <Row className="footer-un-link">
                                    {aboutInfo.phone}
                                </Row>
                                <Row
                                    className="footer-link"
                                    onClick={() => {
                                        window.open(
                                            'mailto:' + aboutInfo.email,
                                            '_blank'
                                        )
                                    }}
                                >
                                    {aboutInfo.email}
                                </Row>
                            </Col>
                        )}
                        {displaySocialMedia && (
                            <Col span={12} md={6}>
                                <Row className="footer-header">
                                    Social Media
                                </Row>
                                <Row>
                                    <Space
                                        direction="horizontal"
                                        className="social-media-icons"
                                        size={16}
                                    >
                                        {aboutInfo.google && (
                                            <img
                                                className="footer-un-link"
                                                src="/images/google.svg"
                                                alt="Google"
                                                onClick={() => {
                                                    window.open(
                                                        aboutInfo.google,
                                                        '_blank'
                                                    )
                                                }}
                                            />
                                        )}
                                        {aboutInfo.twitter && (
                                            <img
                                                className="footer-un-link"
                                                src="/images/twitter.svg"
                                                alt="Twitter"
                                                onClick={() => {
                                                    window.open(
                                                        aboutInfo.twitter,
                                                        '_blank'
                                                    )
                                                }}
                                            />
                                        )}
                                        {aboutInfo.linkedin && (
                                            <img
                                                className="footer-link"
                                                src="/images/linkedin.svg"
                                                alt="Linkedin"
                                                onClick={() => {
                                                    window.open(
                                                        aboutInfo.linkedin,
                                                        '_blank'
                                                    )
                                                }}
                                            />
                                        )}
                                        {aboutInfo.yelp && (
                                            <img
                                                className="footer-link"
                                                src="/images/yelp.svg"
                                                alt="Yelp"
                                                onClick={() => {
                                                    window.open(
                                                        aboutInfo.yelp,
                                                        '_blank'
                                                    )
                                                }}
                                            />
                                        )}
                                    </Space>
                                </Row>
                            </Col>
                        )}
                        <Col span={12} md={6}>
                            <Row className="footer-header">Legal</Row>
                            <Row
                                className="footer-link"
                                onClick={() => {
                                    window.open(
                                        'https://www.zeitro.com/privacy-policy',
                                        '_blank'
                                    )
                                }}
                            >
                                Privacy Policy
                            </Row>
                            <Row
                                className="footer-link"
                                onClick={() => {
                                    window.open(
                                        'https://www.zeitro.com/terms-conditions',
                                        '_blank'
                                    )
                                }}
                            >
                                Terms of Use
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {customerID === 'gmcc' && (
                <div className="p-3" style={{ backgroundColor: '#fff' }}>
                    <GMCCDisclaimer />
                </div>
            )}
        </Footer>
    )
}

export default RootFooter
